export default __webpack_public_path__ + "static/media/Background_00190.e6dd72a9.png";